module.exports = __webpack_public_path__ + "static/media/tag-bd.4c6e0685.svg";